import './polyfills';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { KatSpinner } from '@amzn/katal-react';
import katalReady from '@amzn/katal-components-ready';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import './i18n';
import './logger';
import './index.scss';

katalReady(() => {
  // The Suspense component causes React to display the fallback KatSpinner until
  // the i18n translation strings have been loaded.

  ReactDOM.render(
    <AppInitWrapper>
      <Suspense fallback={<KatSpinner size='large' />}>
        <App />
      </Suspense>
    </AppInitWrapper>,
    document.getElementById('root')
  );
});
